import * as React from 'react'

interface Props {
    color?: string
    size?: number
}

export const AlarmClockIcon: React.FC<Props> = ({ color = 'currentColor', size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Left bell */}
        <circle cx="4.5" cy="4.5" r="2" stroke={color} strokeWidth="1.5" fill="none" />
        {/* Right bell */}
        <circle cx="19.5" cy="4.5" r="2" stroke={color} strokeWidth="1.5" fill="none" />
        {/* Clock body */}
        <circle cx="12" cy="13" r="8" stroke={color} strokeWidth="2" fill="none" />
        {/* Hour hand */}
        <line x1="12" y1="13" x2="12" y2="8.5" stroke={color} strokeWidth="2" strokeLinecap="round" />
        {/* Minute hand */}
        <line x1="12" y1="13" x2="15.5" y2="13" stroke={color} strokeWidth="2" strokeLinecap="round" />
        {/* Left leg */}
        <line x1="7" y1="20" x2="5" y2="22.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
        {/* Right leg */}
        <line x1="17" y1="20" x2="19" y2="22.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
)
